export default "__VITE_PUBLIC_ASSET__0868cac4__"